import { ensureLatAndLng } from "../modules/project";
import { createSelector } from "reselect";
const initialState = {
    geojson: null,
    projectsByHubName: {},
};
export default (state = initialState, action) => {
    switch (action.type) {
        case "PROJECT:ALL:REQUEST":
            return state;
        case "GEOJSON:REQUEST": {
            return { ...state, geojson: null };
        }
        case "GEOJSON:SUCCESS":
            return { ...state, geojson: action.payload };
        case "GEOJSON:FAILURE":
        case "PROJECT:ALL:FAILURE":
            console.error(action.payload);
            return { ...state, error: action.payload };
        case "PROJECT:ALL:SUCCESS":
            const projectsByHubName = action.payload.reduce((acc, row) => {
                if (!ensureLatAndLng(row)) {
                    return acc;
                }
                const category = row["Project Category"];
                if (acc[category]) {
                    acc[category].push(row);
                } else {
                    acc[category] = [row];
                }

                return acc;
            }, {});

            return {
                ...state,
                projectsByHubName,
            };
        default:
            return state;
    }
};

const addHubName = hubName => project => ({ ...project, hubName });

// Selects all data from projectsByHubName in one array.
// It also adds the hubName each item
const selectAllProjects = createSelector(
    state => state.projectsByHubName,
    projectsByHubName => {
        return Object.entries(projectsByHubName)
            .map(([hubName, data]) => data.map(addHubName(hubName)))
            .reduce((acc, val) => acc.concat(val), []);
    }
);
export const selectGeoJSON = state => state.geojson;

export const selectFilteredProjects = createSelector(
    hubNames => hubNames,
    (hubNames, viewingHub) => viewingHub,
    (hubNames, viewingHub, state) => selectAllProjects(state),
    (hubNames, viewingHub, allProjects) => {
        if (viewingHub) {
            return allProjects.filter(d => d.hubName === viewingHub);
        } else if (hubNames && hubNames.length > 0) {
            return allProjects.filter(d => !hubNames.includes(d.hubName));
        } else {
            return allProjects;
        }
    }
);

export const selectAllHubs = createSelector(
    s => s.projectsByHubName,
    projectsByHubName => Object.keys(projectsByHubName).sort()
);



// WEBPACK FOOTER //
// ./src/reducers/data.js